/**
 * @file 404页面
 * @author zhangfengzhi
 * @date 2026-01-01
 * @description 页面不存在的展示页面
 */

'use client';
import { Button, Result } from 'antd';
import { useRouter } from 'next/navigation';
export default function Error404Page() {
    const router = useRouter();
    return (
        <>
            <Result
                status="404"
                title="404"
                subTitle="您请求的页面不存在或已被移动。请检查URL是否正确，或返回首页继续浏览。"
                extra={
                    <Button
                        type="primary"
                        onClick={() => {
                            router.push('/');
                        }}
                        key="back-home"
                    >
                        返回首页
                    </Button>
                }
            />
        </>
    );
}
